import { render } from "./AddDish.vue?vue&type=template&id=04a5f048&scoped=true"
import script from "./AddDish.vue?vue&type=script&lang=js"
export * from "./AddDish.vue?vue&type=script&lang=js"

import "./AddDish.vue?vue&type=style&index=0&id=04a5f048&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a5f048"]])

export default __exports__